import { Flash } from "./types/flash";

export const FLASH_SIGNIN_FAILURE: Flash = {
  kind: "failure",
  message: "Invalid email or password",
};

export const FLASH_SIGNIN_SUCCESS: Flash = {
  kind: "success",
  message: "You have successfully signed in",
};

export const SORTED_SIZES = [
  "XXS",
  "XS",
  "XS/S",
  "S",
  "S/M",
  "M",
  "M/L",
  "L",
  "L/XL",
  "XL",
  "LT",
  "XLT",
  "2XL",
  "2XLT",
  "2XT",
  "2XL/3XL",
  "3XL",
  "3XLT",
  "3XT",
  "4XL",
  "4XLT",
  "4XT",
  "4XL/5XL",
  "5XL",
  "6XL",
  "7XL",
  "NB",
  "0-3MOS",
  "3-6MOS",
  "6MOS",
  "6-12MOS",
  "12MOS",
  "12-18MOS",
  "18MOS",
  "18-24MOS",
  "24MOS",
  "ADJUSTABLE",
  "OS",
  "ONE SIZE",
  "2T",
  "3T",
  "4T",
  "5T",
  "6T",
  "0X",
  "1X",
  "2X",
  "3X",
  "4X",
  "5/6",
  "30",
  "6-8",
  "6-12",
  "7",
  "8",
  "10",
  "10-12",
  "12",
  "14-16",
  "18-20",
  "22-24",
  "26-28",
];
